import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Navigate } from 'react-router-dom';
import { api } from 'src/api';
import { IS_PAYMENT_METHOD } from 'src/constants/payments';
import { USER_ROLES_BY_NAME, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
export const PrivateRoute = _ref => {
  let Component = _ref.component,
    rest = _objectWithoutProperties(_ref, _excluded);
  const userRole = localStorage.getItem(USER_SETTINGS_KEYS.userRole);
  const paygate = JSON.parse(localStorage.getItem(IS_PAYMENT_METHOD));
  const isLoggedIn = api.Account.isLoggedIn();
  const isDemoModeOn = api.Account.isDemoModeOn();
  const userCompany = localStorage.getItem(USER_SETTINGS_KEYS.company) !== 'null';
  const userEmailConfirmed = JSON.parse(localStorage.getItem(USER_SETTINGS_KEYS.emailConfirmed));
  const userPhoneConfirmed = JSON.parse(localStorage.getItem(USER_SETTINGS_KEYS.phoneConfirmed));
  const isUserVerifyEmail = isLoggedIn && userEmailConfirmed;
  const isUserVerifyPhone = isLoggedIn && userPhoneConfirmed;
  if (isLoggedIn && !isUserVerifyEmail) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/profile_saved"
    });
  } else if (isLoggedIn && !isUserVerifyPhone && !userCompany) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/mfa"
    });
  } else if (isLoggedIn && !userCompany) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/company_details"
    });
  } else if (isLoggedIn && !isDemoModeOn && !paygate && userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/paygate"
    });
  }
  return isLoggedIn ? /*#__PURE__*/React.createElement(Component, {
    props: _objectSpread({}, rest)
  }) : /*#__PURE__*/React.createElement(Navigate, {
    to: "/login"
  });
};